<div class="discussionsModal">
  <div class="discussionsModal__top">
    <button aria-label="close modal" class="vc-modal__closeBtn discussionsModal__top__close" [mat-dialog-close]>
      <span class="discussionsModal__top__close__text" i18n="@@MODAL.BUTTON.CLOSE">Close</span>
      <span class="discussionsModal__top__close__cross">
        <vc-sprite-icons [name]="'cross-x-thick'"></vc-sprite-icons>
      </span>
    </button>
    <div class="discussionsModal__top__container">
      <h3 class="discussionsModal__top__title" i18n="@@DISCUSSIONS.MODAL_TITLE">{{ nbDiscussions }} Comments</h3>
      <div class="discussionsModal__top__actions">
        <span
          class="discussionsModal__top__actions__translateByGoogle vc-text-xs"
          i18n="@@DISCUSSIONS.TRANSLATE_BY_GOOGLE"
          >Translated by Google</span
        >
        <button class="discussionsModal__top__actions__translateAll vc-text-s" (click)="toggleTranslateAll()">
          <vc-sprite-icons
            [name]="'translation'"
            class="discussionsModal__top__actions__translateAll__icon"
          ></vc-sprite-icons>
          <span i18n="@@DISCUSSIONS.VIEW_ORIGINAL_VERSION" *ngIf="translateAll; else translateAllText"
            >See Original Version</span
          >
          <ng-template #translateAllText><span i18n="@@DISCUSSIONS.TRANSLATE_ALL">Translate all</span></ng-template>
        </button>
      </div>
    </div>
  </div>
  <div
    class="discussionsModal__listContainer"
    #discussionsModal
    [ngClass]="{
      'discussionsModal__listContainer--borderBottom': showListContainerBorder,
      'discussionsModal__listContainer--noGradient': nbDiscussions === 1
    }"
  >
    <div *ngIf="nbDiscussions !== 0" class="discussionsModal__list" #discussionsMessages>
      <vc-message
        class="discussionsModal__list__message"
        *ngFor="let message of allComments"
        [likedItem]="likedItem"
        [message]="message"
        [isModal]="true"
        [translateAll]="translateAll"
        [product]="product"
        [negotiation]="getNegoByAuthorId(message?.author?.id)"
        [reservation]="reservation"
        [user]="user"
        [editoId]="editoId"
        [showLikeFunctionality]="showLikeFunctionality"
      ></vc-message>
    </div>
  </div>

  <div class="discussionsModal__addMessage">
    <vc-discussions-form
      class="discussionsModal__addMessage__form"
      [commentType]="commentType"
      [isAuthenticated]="isAuthenticated"
      [isModalView]="true"
      [idItem]="product ? product.id : editoId"
      (send)="addNewComment($event)"
      (change)="addContainerMargin($event)"
    ></vc-discussions-form>
  </div>
</div>
